/* External */
import { useIntl } from 'react-intl';

export default function usePlural({ number, translations: { singular, plural } }) {
  const { formatMessage } = useIntl();
  return formatMessage({ id: number === 1 ? singular : plural }, { number });
}
